// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_BLOGS = "Sp\u00e4\u0165 na stenu";
